import script from "./sub_list.vue?vue&type=script&lang=js&setup=true"
export * from "./sub_list.vue?vue&type=script&lang=js&setup=true"

const __exports__ = script;

export default __exports__